import AOS from 'aos';

AOS.init({
  offset: 50,
  duration: 500,
  easing: 'ease',
  delay: 200,
  anchorPlacement: 'top-bottom',
  disable: window.innerWidth < 992
});